import en from './lang/en.js'
import es from './lang/es.js'
import ca from './lang/ca.js'

import store from '@/store'

const DEFAULT_APP_LANG = 'ca'
const AVAILABLE_LANGS = ['ca', 'en', 'es']
require('dayjs/locale/ca')
require('dayjs/locale/en')
require('dayjs/locale/es')
let storeInstance = store
let allStrings = {
  ca: {
    ...ca,
  },
  en: {
    ...en,
  },
  es: {
    ...es,
  },
}

export function initLang() {
  let initLang = navigator.language.split('-')[0]
  let lang = AVAILABLE_LANGS.includes(initLang) ? initLang : DEFAULT_APP_LANG
  if (Object.keys(allStrings).indexOf(lang) < 0) lang = Object.keys(allStrings)[0]

  storeInstance.dispatch('setLanguage', lang)
  return storeInstance.state.i18n.lang
}

export function t(key) {
  let lang = storeInstance.state.i18n.lang || initLang()
  // hace "fallback" a idiomas "parceidos" (es <-> es-ES)
  let availableLang =
    Object.keys(allStrings).indexOf(lang) >= 0
      ? lang
      : Object.keys(allStrings).find(l => l.indexOf(lang) >= 0 || lang.indexOf(l) >= 0)
  let aux = availableLang && allStrings[availableLang][key]
  return aux != undefined ? aux : '[' + key + ']'
}

export const langISODict = {
  es: 'es-ES',
  en: 'en-US',
  ca: 'ca-ES',
}

export default {
  methods: {
    $t: t,
  },
}
